import React, { FC, useEffect, useState } from 'react';
import { Button, Modal } from '../../kit';

const VideoPopup: FC = (): JSX.Element => {
    const [ open, setOpen ] = useState<boolean>(true);

    useEffect(() => {
        localStorage.setItem('first-time', '1');
    }, []);

    return (
        <Modal
            header="Welkom in de community!"
            onClose={() => setOpen(false)}
            open={open}
            size="large"
            footer={(
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        color="primary"
                        label="Starten!"
                        onClick={() => setOpen(false)}
                    />
                </div>
            )}
        >
            <div className="ratio ratio-16x9">
                <iframe src="https://player.vimeo.com/video/820508113?h=719b72e15e&byline=0&portrait=0" />
            </div>
        </Modal>
    );
}

export default VideoPopup;
